/*@ngInject*/
const GenerateDataDictionaryRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.generateDataDictionary = function () {
        const url = '/rest/Integration/generateDataDictionary';
        return this.post(url);
    };

};
angular.module('ums.configuration')
    .service('generateDataDictionaryRepository', GenerateDataDictionaryRepository);
